__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "x_vp_wpk";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@razorpay/i18nify-js", "1.12.2", () => (Promise.all([__webpack_require__.e(51), __webpack_require__.e(19)]).then(() => (() => (__webpack_require__(1051))))));
			register("@razorpay/i18nify-react", "4.0.0", () => (Promise.all([__webpack_require__.e(48), __webpack_require__.e(993)]).then(() => (() => (__webpack_require__(52048))))));
			register("@reduxjs/toolkit", "1.9.1", () => (Promise.all([__webpack_require__.e(939), __webpack_require__.e(715), __webpack_require__.e(843)]).then(() => (() => (__webpack_require__(97939))))));
			register("extensible-duck", "1.6.0", () => (__webpack_require__.e(996).then(() => (() => (__webpack_require__(87996))))));
			register("prop-types", "15.8.1", () => (__webpack_require__.e(697).then(() => (() => (__webpack_require__(45697))))));
			register("react-focus-lock", "2.9.3", () => (Promise.all([__webpack_require__.e(791), __webpack_require__.e(14), __webpack_require__.e(993), __webpack_require__.e(957), __webpack_require__.e(698)]).then(() => (() => (__webpack_require__(14791))))));
			register("react-redux", "7.2.9", () => (Promise.all([__webpack_require__.e(424), __webpack_require__.e(993), __webpack_require__.e(957), __webpack_require__.e(180), __webpack_require__.e(634)]).then(() => (() => (__webpack_require__(37424))))));
			register("resize-observer-polyfill", "1.5.1", () => (__webpack_require__.e(18).then(() => (() => (__webpack_require__(32018))))));
			register("styled-components", "5.3.11", () => (Promise.all([__webpack_require__.e(993), __webpack_require__.e(384)]).then(() => (() => (__webpack_require__(78384))))));
			register("timm", "1.7.1", () => (__webpack_require__.e(11).then(() => (() => (__webpack_require__(7011))))));
			initExternal(99743);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};